import { createExtensionClient } from "./client.js";
export const importSql = (directory = "") => `PRAGMA gtfs_import('${directory.replaceAll("'", "''")}');`;
export const addGeomColumnsSql = () => "PRAGMA gtfs_add_geometry;";
export async function importGtfs(executor, opts) {
    if (!opts.routesPath || !opts.tripsPath || !opts.stopTimesPath || !opts.shapesPath || (!opts.calendarPath && !opts.calendarDatesPath)) {
        throw new Error("Downloaded extension does not support skipping indexes. Import all related files; no fallback was attempted.");
    }
    const client = createExtensionClient({ query: executor }, { repository: opts.extensionRepository });
    const report = (phase, done, total) => opts.onProgress?.({ phase, done, total });
    report("macros", 0, 1);
    if (opts.extensionRepository !== undefined)
        await client.install();
    await client.load();
    report("macros", 1, 1);
    report("import", 0, 1);
    await client.importDirectory(opts.directory ?? "");
    report("import", 1, 1);
    await opts.onCsvImported?.();
}
//# sourceMappingURL=ingestion.js.map